<template>
    <div
        class="relative flex h-auto w-full flex-col gap-2 rounded-md border border-gray-200 bg-white p-8"
    >
        <div
            class="absolute right-2 top-2 flex h-auto w-auto items-start justify-start space-x-2 p-2"
        >
            <button
                class="btn btn-primary space-x-2 bg-red-500 text-white"
                @click="removeBlock"
            >
                <fa icon="fa-trash-can" />
            </button>
            <button
                class="btn btn-primary space-x-2 bg-blue-500 text-white"
                @click="moveBlockUp"
            >
                <fa icon="fa-arrow-up-wide-short" />
            </button>
            <button
                class="btn btn-primary space-x-2 bg-blue-500 text-white"
                @click="moveBlockDown"
            >
                <fa
                    icon="fa-arrow-up-wide-short"
                    class="rotate-180"
                />
            </button>
        </div>
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
import { useEventBus } from '@vueuse/core'

const props = defineProps<{ id: string }>()

const blockBus = useEventBus('blockActions')

const removeBlock = () => {
    blockBus.emit({ type: 'removeBlock', id: props.id })
}

const moveBlockUp = () => {
    blockBus.emit({ type: 'moveBlockUp', id: props.id })
}

const moveBlockDown = () => {
    blockBus.emit({ type: 'moveBlockDown', id: props.id })
}
</script>
